<script setup lang="ts">
import { LoadingStatus } from '@itinerary/ItineraryModuleTypes';
import { BillErrors } from '@clients/BillApi';

const emit = defineEmits<{
    close: [];
}>();
const trackingStore = useTrackingStore();
const { loadingStatus } = classToRefs(trackingStore);
const router = useRouter();

const billCode = ref('');
const mobile = ref('');
const error = ref<Record<string, boolean>>({});

const loading = computed(() => loadingStatus.value === LoadingStatus.Loading);

watch(mobile, (value, oldValue) => {
    if (value.length > 11) {
        nextTick(() => {
            mobile.value = oldValue;
        });
    }
});

async function submit() {
    // Validation
    error.value.billCode = !/\d{7,8}/.test(billCode.value);
    error.value.mobile = !/09\d{9}/.test(mobile.value);

    if (error.value.billCode || error.value.mobile) {
        return;
    }

    try {
        await trackingStore.loadBill({
            billCode: billCode.value,
            mobile: mobile.value,
        });
        emit('close');
        setTimeout(() => {
            router.push('/support/tracking');
        }, 200);
    } catch (error) {
        if (error === BillErrors.NotFound) {
            swal({
                icon: 'warning',
                title: 'بلیط مورد نظر یافت نشد.',
                text: 'شماره صورتحساب یا تلفن همراه اشتباه است.',
                confirmButtonText: 'باشه',
            });
        } else {
            handleException(error);
        }
    }
}
</script>

<template>
    <mr-modal title="پیگیری و کنسلی بلیط" width="320px" @close="emit('close')">
        <form onsubmit="return false;">
            <p>شماره صورتحساب و تلفن همراه خود را وارد کنید.</p>
            <mr-input
                v-model="billCode"
                input-id="bill-code"
                required
                type="number"
                placeholder="شماره صورتحساب"
                error-text="شماره صورتحساب صحیح نیست."
                :invalid="!!error.billCode"
            />

            <mr-input
                v-model="mobile"
                input-id="mobile"
                required
                type="number"
                placeholder="تلفن همراه"
                :max="11"
                error-text="تلفن همراه صحیح نیست."
                :invalid="!!error.mobile"
                @submit="submit"
            />

            <mr-fade-loading
                :scale="2.5"
                class="loading"
                :class="{ show: loading }"
            />
            <mr-button :disabled="loading" full-width @click="submit">
                مشاهده بلیط
            </mr-button>
        </form>
    </mr-modal>
</template>

<style scoped lang="scss">
p {
    @include tg-m;
}

.loading {
    margin-bottom: 10px !important;
    visibility: hidden;

    &.show {
        visibility: visible;
    }
}
</style>
